// Simple, elegant splash — shows the actual Hood logo with a soft glow. No text overlays, no grid clutter.
import { useEffect, useState } from "react";

const SHOWN_KEY = "kh_splash_shown_v2";

export function Splash() {
  const [visible, setVisible] = useState(() => {
    if (typeof window === "undefined") return false;
    return !sessionStorage.getItem(SHOWN_KEY);
  });

  useEffect(() => {
    if (!visible) return;
    const t = setTimeout(() => {
      setVisible(false);
      try { sessionStorage.setItem(SHOWN_KEY, "1"); } catch { /* ignore */ }
    }, 1800);
    return () => clearTimeout(t);
  }, [visible]);

  if (!visible) return null;

  return (
    <div
      className="fixed inset-0 z-[999] flex items-center justify-center pointer-events-none"
      data-testid="splash-screen"
      style={{
        background: "radial-gradient(1000px 700px at 50% 50%, #0C2E20 0%, #06120D 60%, #03080A 100%)",
        animation: "hood-splash-out 1.8s ease-out forwards",
      }}
    >
      <style>{`
        @keyframes hood-splash-out { 0%, 78% { opacity: 1; } 100% { opacity: 0; } }
        @keyframes hood-logo-in {
          0%   { opacity: 0; transform: scale(.85); }
          60%  { opacity: 1; transform: scale(1.02); }
          100% { opacity: 1; transform: scale(1); }
        }
        @keyframes hood-halo-pulse {
          0%, 100% { opacity: .35; transform: scale(1); }
          50%      { opacity: .55; transform: scale(1.08); }
        }
      `}</style>

      {/* Soft green halo behind logo */}
      <div
        className="absolute w-[380px] h-[380px] rounded-full blur-3xl"
        style={{
          background: "radial-gradient(circle, #1DCF75 0%, transparent 65%)",
          animation: "hood-halo-pulse 2s ease-in-out infinite",
        }}
      />

      {/* Logo tile */}
      <div
        className="relative rounded-[32px] p-2 shadow-2xl"
        style={{
          animation: "hood-logo-in .8s cubic-bezier(.2,.9,.3,1) both",
          background: "linear-gradient(145deg, rgba(29,207,117,0.15), rgba(29,207,117,0.02))",
          border: "1px solid rgba(29,207,117,0.25)",
          boxShadow: "0 30px 80px -20px rgba(29,207,117,0.5)",
        }}
      >
        <img
          src="/hood-icon.png"
          alt="Hood"
          className="w-32 h-32 rounded-[26px] object-cover"
        />
      </div>
    </div>
  );
}
